export const ELearningRoutes = {
    trainings: (origin: string) => `${origin}/learning`,
    learningFilters: (origin: string) => `${origin}/learning/filters`,
};
